<search-dialog-page [model]="model" (onAction)="action($event)">
  <div class="container-fluid">
    <ep-row class="col-12">
      <form
        (ngSubmit)="dsCollection.refresh(); model.dirty = false"
        (keypress)="model.dirty = true"
        style="width: 100%; margin-bottom: 0px; margin-top: 0px"
      >
        <ep-row>
          <div class="col-12 col-md-6 col-lg-4">
            <div class="unity-form-group" style="display: inline-block">
              <label for="Form_Num">Form Num</label>
              <input
                myFocus
                type="text"
                name="Form_Num"
                [(ngModel)]="dsCollection.criteria.Form_Num"
                ngControl="Form_Num"
                (valueChange)="model.dirty = true"
              />
            </div>
          </div>
          <div class="col-12 col-md-6 col-lg-4">
            <div class="unity-form-group" style="display: inline-block">
              <label for="Form_Name">Form Name</label>
              <input
                type="text"
                name="Form_Name"
                [(ngModel)]="dsCollection.criteria.Form_Name"
                ngControl="Form_Name"
                (valueChange)="model.dirty = true"
              />
            </div>
          </div>
          <div class="col-12 col-lg-4">
            <unity-button-old
              [loading]="dsCollection && dsCollection.status == 'Loading'"
              [dirty]="model.dirty"
              class="pull-right margin-l-5"
              style="margin-top: 16px"
              type="submit"
              classes="primary"
            >
              Search
            </unity-button-old>
          </div>
        </ep-row>
      </form>
    </ep-row>

    <ep-row>
      <div
        class="col-12"
        style="margin: 5px 5px 5px 5px; border-top: solid 1px; padding-top: 5px; border-top-color: #e5e3e3"
      >
        <ep-filter-input
          #formFilter
          style="margin-bottom: 5px"
          [filter]="{ filterKey: '[GLOBAL]', maxDepth: 5 }"
        ></ep-filter-input>

        <ep-max-row-warning [datasource]="dsCollection"></ep-max-row-warning>

        <div
          class="table-responsive"
          style="max-height: 400px; min-height: 400px; overflow-y: scroll; margin-top: 5px; border: 1px solid silver"
        >
          <table class="table table-select table-fixed-header" style="min-width: 700px">
            <tr>
              <th *ngIf="model.currentOptions.allowMultiSelect === true"></th>
              <th>Form Num</th>
              <th>Form Name</th>
              <th>Form Edition Date</th>
              <th>Collating Seq</th>
            </tr>
            <tr
              [class.active]="form.Selected"
              *ngFor="
                let form of dsCollection.objectNodes | epFilter : formFilter.filter : formFilter.filter.filterText;
                let idx = index
              "
              (click)="app.getSelectedText() && recordClicked(form, $event)"
            >
              <td
                *ngIf="model.currentOptions.allowMultiSelect === true"
                style="text-align: center"
                (click)="app.stopNavigation($event)"
              >
                <i
                  *ngIf="!form.Selected"
                  class="fa fa-ep-selected-false-square"
                  style="margin-top: 3px"
                  (click)="checkboxClicked(form)"
                ></i>
                <i
                  *ngIf="form.Selected"
                  class="fa fa-ep-selected-square"
                  style="margin-top: 3px"
                  (click)="checkboxClicked(form)"
                ></i>
              </td>
              <td>
                {{ form.Form_Num }}
              </td>
              <td>
                {{ form.Form_Name }}
              </td>
              <td>
                {{ form.Form_Edition_Date | epDate : 'mm/dd/yy' }}
              </td>
              <td>
                {{ form.Collating_Seq }}
              </td>
            </tr>

            <tr
              class="col-12"
              *ngIf="
                !(dsCollection.objectNodes && dsCollection.objectNodes.length > 0) && dsCollection.status == 'Ready'
              "
            >
              <td>
                <span style="text-align: center"><i>No Forms</i></span>
              </td>
            </tr>
          </table>
        </div>
      </div>
    </ep-row>
  </div>
</search-dialog-page>
